import { render, staticRenderFns } from "./retirosLeecheros.vue?vue&type=template&id=42c8e661&scoped=true"
import script from "./retirosLeecheros.vue?vue&type=script&lang=js"
export * from "./retirosLeecheros.vue?vue&type=script&lang=js"
import style0 from "./retirosLeecheros.vue?vue&type=style&index=0&id=42c8e661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8e661",
  null
  
)

export default component.exports